import React from 'react'
import styles from "styles/pages/Pages.module.scss";
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { RenderDivision } from './RenderDivision';
import { RenderUnit } from './RenderUnit';

export const RenderSection = (section, allElements, elementIndex, expanded, toggleExpand, getChildren, calculateElementRows, calculateRowStart, hanndleSelectId, id) => {
        const divisions = getChildren(section.id, "division");
        const directUnits = getChildren(section.id, "unit");
        const isExpanded = expanded[section.id];
        const hasChildren = divisions.length > 0 || directUnits.length > 0;

        const totalRows = calculateElementRows(section);
        const sectionRowStart = calculateRowStart(allElements, elementIndex);

        let currentRow = sectionRowStart;
        const childrenWithRows = [];
        
        if (isExpanded) {
            divisions.forEach(div => {
                childrenWithRows.push({ type: 'division', item: div, row: currentRow });
                const units = getChildren(div.id, "unit");
                if (expanded[div.id] && units.length > 0) {
                    currentRow += units.length;
                } else {
                    currentRow += 1;
                }
            });

            directUnits.forEach(unit => {
                childrenWithRows.push({ type: 'unit', item: unit, row: currentRow });
                currentRow += 1;
            });
        }

        return (
            <React.Fragment key={section.id}>
                <div 
                    className={`${styles.containerSectionInfo} ${section.id === id && styles.select}`}
                    style={{ 
                        gridColumn: '1',
                        gridRow: `${sectionRowStart} / span ${totalRows}`
                    }}
                    onClick={() => hanndleSelectId(section.id)}
                >
                    <div className={styles.sectionText}>
                        {hasChildren && (
                            <div onClick={(e) => toggleExpand(section.id, e)}>
                                {isExpanded ? 
                                    <ChevronRightRoundedIcon size={20} /> : 
                                    <ChevronLeftRoundedIcon size={20} />
                                }
                            </div>
                        )}
                        <span className={styles.sectionName}>{section.name}</span>
                    </div>
                </div>
                
                {isExpanded && hasChildren && (
                    <>
                        {childrenWithRows.map(child => {
                            if (child.type === 'division') {
                                return RenderDivision(child.item, child.row, getChildren, hanndleSelectId, expanded, id, toggleExpand);
                            } else {
                                return RenderUnit(child.item, child.row, hanndleSelectId, id);
                            }
                        })}
                    </>
                )}                
            </React.Fragment>
        );
    };
